// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/image-with-large-text-left/image-with-large-text-left.component.scss
// module id = 538
// module chunks = 0